var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYellowLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5306 3.625V20.125C16.5306 21.9713 17.8076 23 19.1622 23C20.4154 23 21.7938 22.125 21.7938 20.125V3.75C21.7938 2.0575 20.5407 1 19.1622 1C17.7838 1 16.5306 2.16625 16.5306 3.625Z",
    fill: "#FFDA96"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63837 12.0001V20.1251C9.63837 21.9714 10.9153 23.0001 12.27 23.0001C13.5231 23.0001 14.9016 22.1251 14.9016 20.1251V12.1251C14.9016 10.4326 13.6484 9.37512 12.27 9.37512C10.8915 9.37512 9.63837 10.5414 9.63837 12.0001Z",
    fill: "#FAC86B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.37763 23.0001C6.83101 23.0001 8.00922 21.8249 8.00922 20.3751C8.00922 18.9254 6.83101 17.7501 5.37763 17.7501C3.92424 17.7501 2.74603 18.9254 2.74603 20.3751C2.74603 21.8249 3.92424 23.0001 5.37763 23.0001Z",
    fill: "#FAC86B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLogo);
export default __webpack_public_path__ + "static/media/yellow-logo.0719114517ea861f74c1489948c05b6d.svg";
export { ForwardRef as ReactComponent };